import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export const PageLoader: React.FunctionComponent = () => (
  <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
    <CircularProgress color="primary" />
  </Box>
);
